import { render, staticRenderFns } from "./TagsController.vue?vue&type=template&id=32ee923f&scoped=true&"
import script from "./TagsController.vue?vue&type=script&lang=ts&"
export * from "./TagsController.vue?vue&type=script&lang=ts&"
import style0 from "./TagsController.vue?vue&type=style&index=0&id=32ee923f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ee923f",
  null
  
)

export default component.exports